"use client";
import React from "react";
import { Controller } from "react-hook-form";
import ErrorMessage from "@/components/shared/Form/ErrorMessage";

interface InputProps {
  placeholder: string;
  name: any;
  control: any;
  errors: any;
  inputClassName?: string;
  wrapClassName?: string;
  subTitle?: string;
  [key: string]: any;
  image?: any;
}

const Input: React.FC<InputProps> = ({
  placeholder,
  name,
  control,
  errors,
  inputClassName,
  wrapClassName,
  subTitle,
  image,
  ...props
}) => {
  // console.log("nameInput", name);
  // console.log("errorsInput", errors);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div
          className={`w-full p-2.5 bg-[#fdfdfd] rounded-md border border-[#eeeeee] flex justify-end flex-col gap-2.5 ${wrapClassName}`}
        >
          <div className="flex items-center justify-between">
            {image && <div className=" rounded-md ml-2 ">{image}</div>}
            <input
              type="text"
              placeholder={placeholder}
              className={` w-full  text-[#6c7278] text-sm bg-transparent border-none focus:outline-none ${inputClassName}`}
              value={(field.value as string) ?? ""}
              onChange={(e) => field.onChange(e.target.value)}
              onBlur={field.onBlur}
              {...props}
            />{" "}
          </div>{" "}
          <ErrorMessage errors={errors} name={name} />
        </div>
      )}
    />
  );
};

export default Input;
